// Coordonnées générées via geo.api.gouv.fr (centre des communes)
export const CITY_COORDS = {
    "mont-dol": [
        48.5713,
        -1.7578
    ],
    "dol-de-bretagne": [
        48.5338,
        -1.7467
    ],
    "le-vivier-sur-mer": [
        48.5958,
        -1.7791
    ],
    "hirel": [
        48.5935,
        -1.8143
    ],
    "cherrueix": [
        48.591,
        -1.7186
    ],
    "baguer-pican": [
        48.551,
        -1.691
    ],
    "baguer-morvan": [
        48.5037,
        -1.7712
    ],
    "roz-landrieux": [
        48.5472,
        -1.8203
    ],
    "la-fresnais": [
        48.5846,
        -1.8383
    ],
    "lillemer": [
        48.5703,
        -1.8538
    ],
    "saint-broladre": [
        48.5786,
        -1.6641
    ],
    "saint-marcan": [
        48.5855,
        -1.628
    ],
    "roz-sur-couesnon": [
        48.5926,
        -1.596
    ],
    "saint-georges-de-grehaigne": [
        48.5823,
        -1.547
    ],
    "epiniac": [
        48.4974,
        -1.7047
    ],
    "la-boussac": [
        48.5155,
        -1.6509
    ],
    "broualan": [
        48.4733,
        -1.6607
    ],
    "trans-la-foret": [
        48.4872,
        -1.6016
    ],
    "pleine-fougeres": [
        48.5317,
        -1.5722
    ],
    "sains": [
        48.5557,
        -1.5968
    ],
    "saint-guinoux": [
        48.5793,
        -1.8894
    ],
    "miniac-morvan": [
        48.5215,
        -1.896
    ],
    "plerguer": [
        48.534,
        -1.8478
    ],
    "saint-benoit-des-ondes": [
        48.6135,
        -1.86
    ],
    "la-gouesniere": [
        48.603,
        -1.8901
    ],
    "saint-meloir-des-ondes": [
        48.639,
        -1.9053
    ],
    "cancale": [
        48.6895,
        -1.8598
    ],
    "saint-coulomb": [
        48.6807,
        -1.9236
    ],
    "saint-malo": [
        48.6465,
        -2.0066
    ],
    "saint-jouan-des-guerets": [
        48.6043,
        -1.9667
    ],
    "saint-pere-marc-en-poulet": [
        48.5852,
        -1.9281
    ],
    "saint-suliac": [
        48.5713,
        -1.967
    ],
    "la-ville-es-nonais": [
        48.5504,
        -1.9508
    ],
    "chateauneuf-d-ille-et-vilaine": [
        48.5579,
        -1.9287
    ],
    "le-tronchet": [
        48.4921,
        -1.8404
    ],
    "bonnemain": [
        48.4709,
        -1.7715
    ],
    "meillac": [
        48.4285,
        -1.8268
    ],
    "combourg": [
        48.4111,
        -1.7333
    ],
    "tremeheuc": [
        48.4396,
        -1.6954
    ],
    "cuguen": [
        48.435,
        -1.6581
    ],
    "lourmais": [
        48.4397,
        -1.734
    ],
    "lanrigan": [
        48.3908,
        -1.6926
    ],
    "dinard": [
        48.629,
        -2.0602
    ],
    "la-richardais": [
        48.61,
        -2.043
    ],
    "pleurtuit": [
        48.5791,
        -2.0696
    ],
    "le-minihic-sur-rance": [
        48.5737,
        -2.011
    ],
    "saint-lunaire": [
        48.62,
        -2.1004
    ],
    "saint-briac-sur-mer": [
        48.6172,
        -2.13
    ],
    "dinan": [
        48.4471,
        -2.0533
    ],
    "lanvallay": [
        48.4533,
        -2.0018
    ],
    "taden": [
        48.4867,
        -2.0536
    ],
    "quevert": [
        48.466,
        -2.0852
    ],
    "aucaleuc": [
        48.452,
        -2.1237
    ],
    "trelivan": [
        48.427,
        -2.1025
    ],
    "bobital": [
        48.4133,
        -2.098
    ],
    "brusvily": [
        48.3922,
        -2.1174
    ],
    "le-hingle": [
        48.3993,
        -2.0815
    ],
    "trevron": [
        48.3909,
        -2.0682
    ],
    "saint-carne": [
        48.4193,
        -2.0517
    ],
    "calorguen": [
        48.4061,
        -2.0248
    ],
    "saint-helen": [
        48.466,
        -1.9639
    ],
    "evran": [
        48.3771,
        -1.9773
    ],
    "saint-judoce": [
        48.3646,
        -1.952
    ],
    "saint-andre-des-eaux": [
        48.3745,
        -2.0131
    ],
    "trefumel": [
        48.3401,
        -2.0236
    ],
    "le-quiou": [
        48.3464,
        -1.9963
    ],
    "saint-jacut-de-la-mer": [
        48.6001,
        -2.1943
    ],
    "crehen": [
        48.5447,
        -2.1869
    ],
    "tregon": [
        48.56462,
        -2.18218
    ],
    "plancoet": [
        48.5176,
        -2.2184
    ],
    "corseul": [
        48.4846,
        -2.1675
    ],
    "saint-lormel": [
        48.5494,
        -2.2375
    ],
    "saint-cast-le-guildo": [
        48.6077,
        -2.2499
    ],
    "matignon": [
        48.6023,
        -2.2916
    ],
    "saint-potan": [
        48.5589,
        -2.2977
    ],
    "pleboulle": [
        48.5951,
        -2.33
    ],
    "frehel": [
        48.6334,
        -2.3713
    ],
    "plevenon": [
        48.6581,
        -2.3171
    ],
    "plurien": [
        48.6115,
        -2.3959
    ],
    "erquy": [
        48.618,
        -2.4571
    ],
    "tinteniac": [
        48.3182,
        -1.8298
    ],
    "quebriac": [
        48.3579,
        -1.8106
    ],
    "saint-domineuc": [
        48.3611,
        -1.8695
    ],
    "trimer": [
        48.3477,
        -1.8956
    ],
    "la-chapelle-aux-filtzmeens": [
        48.3828,
        -1.8182
    ],
    "hede-bazouges": [
        48.3009,
        -1.7777
    ],
    "dinge": [
        48.3414,
        -1.7011
    ],
    "guipel": [
        48.2942,
        -1.7244
    ],
    "montreuil-sur-ille": [
        48.3053,
        -1.668
    ],
    "saint-medard-sur-ille": [
        48.2764,
        -1.6803
    ],
    "melesse": [
        48.2192,
        -1.6887
    ],
    "la-meziere": [
        48.2135,
        -1.7504
    ],
    "geveze": [
        48.2075,
        -1.7918
    ],
    "vignoc": [
        48.2589,
        -1.7644
    ],
    "montgermont": [
        48.1547,
        -1.7167
    ],
    "betton": [
        48.1797,
        -1.6477
    ],
    "saint-gregoire": [
        48.1598,
        -1.6815
    ],
    "pace": [
        48.1535,
        -1.7744
    ],
    "rennes": [
        48.1159,
        -1.6884
    ],
    "cesson-sevigne": [
        48.1235,
        -1.5935
    ],
    "thorigne-fouillard": [
        48.1524,
        -1.5866
    ],
    "acigne": [
        48.1461,
        -1.5189
    ],
    "chantepie": [
        48.0831,
        -1.6064
    ],
    "noyal-chatillon-sur-seiche": [
        48.053,
        -1.661
    ],
    "saint-jacques-de-la-lande": [
        48.0779,
        -1.7252
    ],
    "bruz": [
        48.024,
        -1.7469
    ],
    "le-rheu": [
        48.0971,
        -1.7882
    ],
    "vezin-le-coquet": [
        48.116,
        -1.7528
    ],
    "mordelles": [
        48.0853,
        -1.8515
    ],
    "fougeres": [
        48.3512,
        -1.1953
    ],
    "vitre": [
        48.1105,
        -1.1972
    ],
    "plelan-le-petit": [
        48.4274,
        -2.2256
    ],
    "vilde-guingalan": [
        48.4351,
        -2.1532
    ],
    "saint-maudez": [
        48.4549,
        -2.1798
    ],
    "bourseul": [
        48.4662,
        -2.2606
    ],
    "pledeliac": [
        48.4645,
        -2.3675
    ],
    "jugon-les-lacs": [
        48.4014,
        -2.3217
    ],
    "plenee-jugon": [
        48.3537,
        -2.412
    ],
    "sevignac": [
        48.3312,
        -2.3244
    ],
    "plestan": [
        48.4135,
        -2.428
    ],
    "noyal": [
        48.4513,
        -2.4641
    ],
    "lamballe-armor": [
        48.4859,
        -2.5201
    ],
    "landehen": [
        48.4188,
        -2.5441
    ],
    "andel": [
        48.493,
        -2.5549
    ],
    "coetmieux": [
        48.4868,
        -2.5904
    ],
    "pommeret": [
        48.4599,
        -2.6215
    ],
    "yffiniac": [
        48.4692,
        -2.6862
    ],
    "hillion": [
        48.5042,
        -2.6453
    ],
    "langueux": [
        48.502,
        -2.7087
    ],
    "tregueux": [
        48.4769,
        -2.7454
    ],
    "ploufragan": [
        48.4915,
        -2.8001
    ],
    "saint-brieuc": [
        48.5108,
        -2.7657
    ],
    "pontorson": [
        48.5612,
        -1.462
    ],
    "avranches": [
        48.6759,
        -1.3452
    ],
    "granville": [
        48.8724,
        -1.7657
    ],
    "lancieux": [
        48.6034,
        -2.1479
    ],
    "beaussais-sur-mer": [
        48.5627,
        -2.1383
    ],
    "tremereuc": [
        48.5601,
        -2.0634
    ],
    "langrolay-sur-rance": [
        48.5547,
        -2.0151
    ],
    "plouer-sur-rance": [
        48.5254,
        -2.0064
    ],
    "pleudihen-sur-rance": [
        48.5138,
        -1.9451
    ],
    "saint-samson-sur-rance": [
        48.49,
        -2.0172
    ],
    "la-vicomte-sur-rance": [
        48.4882,
        -1.9834
    ],
    "lehon": [
        48.44144,
        -2.03954
    ],
    "treverien": [
        48.3718,
        -1.9152
    ],
    "pleugueneuc": [
        48.4054,
        -1.8851
    ],
    "plorec-sur-arguenon": [
        48.4653,
        -2.3024
    ],
    "tramain": [
        48.4001,
        -2.3877
    ],
    "meslin": [
        48.44313,
        -2.58348
    ],
    "saint-pierre-de-plesguen": [
        48.45621,
        -1.88431
    ],
    "pluduno": [
        48.52374,
        -2.28894
    ],
    "ducey": [
        48.62,
        -1.2661
    ]
};
